<template>
  <div>
    <title-bar title="设备运行统计">
      <el-button type="default" @click="$router.back()" icon="fa fa-angle-left">返回</el-button>
    </title-bar>
    <div class="page-body">
      <el-form inline>
        <el-form-item label="统计日期">
          <el-date-picker v-model="dates" type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          value-format="yyyy-MM-dd"
                          :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-button type="primary" icon="fa fa-search" :loading="loading" @click="query">查询</el-button>
        <el-button type="primary" :loading="loading" @click="download">导出</el-button>
      </el-form>

      <el-table stripe :data="records" :border="true" v-loading="loading">
        <el-table-column type="index" label="序号" width="50" align="center" fixed></el-table-column>
        <el-table-column prop="dt" label="日期" align="center" min-width="80" fixed></el-table-column>
        <el-table-column prop="kwh" label="电表(KWH)" align="center" min-width="90"></el-table-column>
        <el-table-column prop="dayKwh" label="日耗电(KWH)" align="center" min-width="90"></el-table-column>
        <el-table-column prop="money" label="预估节能(元)" align="center" min-width="90"></el-table-column>
        <el-table-column prop="maxInTemp" label="最高室内温度(℃)" align="center" min-width="100"></el-table-column>
        <el-table-column prop="maxOutTemp" label="最高室外温度(℃)" align="center" min-width="100"></el-table-column>
        <el-table-column prop="maxInWet" label="最高室内湿度(%)" align="center" min-width="100"></el-table-column>
        <el-table-column label="运行时间统计（小时）" align="center">
          <el-table-column prop="acRunMinutes" label="空调" align="center" min-width="100" v-slot="{row, $index}">
            {{ row.acRunMinutes ? (row.acRunMinutes/60).toFixed(1) : 0 }}
          </el-table-column>
          <el-table-column prop="fanRunMinutes" label="新风" align="center" min-width="100" v-slot="{row, $index}">
            {{ row.fanRunMinutes ? (row.fanRunMinutes/60).toFixed(1) : 0 }}
          </el-table-column>
<!--          <el-table-column prop="hignTempMinutes" label="高温告警时间" align="center" min-width="100" v-slot="{row, $index}">
            {{ row.hignTempMinutes ? (row.hignTempMinutes/60).toFixed(1) : 0 }}
          </el-table-column>-->
        </el-table-column>
      </el-table>
      <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
export default {
  components: {TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      dates: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      queryForm: {
        deviceCode: '',
        startDate: '',
        endDate: '',
        page: 1,
        limit: 10
      },
      total: 0,
      records: []
    }
  },
  created() {
    this.queryForm.deviceCode = this.$route.query.deviceCode;
    this.loadData();
  },
  methods: {
    query(){
      if(this.dates.length > 0) {
        this.queryForm.startDate = this.dates[0];
        this.queryForm.endDate = this.dates[1];
      }
      this.queryForm.page = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/device-day-info/v2/list", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    },
    download(){
      window.open(this.globalConfig.apiRoot+"/device-day-info/export?deviceCode="+this.queryForm.deviceCode
          +"&startDate="+(this.queryForm.startDate||"")
          +"&endDate="+(this.queryForm.endDate||"")
      );
    }
  }
}
</script>

<style scoped>

</style>